const stripTags = require("locutus/php/strings/strip_tags");
const StripHtml = {
  install(Vue) {
    Vue.filter('striphtml', htmlText => {
      return stripTags(htmlText);
    });
  },
};

export default StripHtml;
